import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { useAuth } from "@/lib/auth";
import PushNotificationsCard from "@/components/PushNotificationsCard";

export default function NotificationsPage() {
  const [notifs, setNotifs] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/notifications", { params: { limit: 50 } });
      setNotifs(data.notifications || []);
      if (user) {
        try { await api.post("/notifications/mark-read"); } catch {}
        window.dispatchEvent(new Event("loot:notifications-read"));
      }
    })();
  }, [user]);

  return (
    <div className="py-8 space-y-6">
      <div>
        <div className="overline">Drop alerts & updates</div>
        <h1 className="font-display uppercase text-5xl tracking-tight mt-2">
          Notifications
        </h1>
      </div>

      {/* Enable / disable browser push right at the top. */}
      <PushNotificationsCard />

      <div className="loot-card-flat divide-y divide-[#F5F2E8]/10">
        {notifs.length === 0 && (
          <div className="p-8 text-[#F5F2E8]/60 flex items-center gap-3">
            <Bell size={18} /> Nothing to show yet.
          </div>
        )}
        {notifs.map((n) => (
          <div key={n.id} className="p-5" data-testid={`notif-${n.id}`}>
            <div className="flex items-center gap-2">
              <span
                className="tag-pill"
                style={{
                  color:
                    n.tag === "winner" ? "#D7A62A" :
                    n.tag === "drop" ? "#E53935" : "#76B82A",
                  borderColor:
                    n.tag === "winner" ? "#D7A62A" :
                    n.tag === "drop" ? "#E53935" : "#76B82A",
                }}
              >
                {n.tag}
              </span>
              {n.city && <span className="font-mono text-[10px] text-[#F5F2E8]/50">{n.city}</span>}
            </div>
            <div className="font-display uppercase text-2xl mt-2 leading-tight">{n.title}</div>
            <div className="text-sm text-[#F5F2E8]/70 mt-1">{n.message}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
